export default (email) => ({
    type: 'SET_INITIATE_REGISTER_EMAIL',
    payload: {
        email,
    },
});
